






import Vue from 'vue'
import SpellList from '@/components/SpellList.vue'
import SpellListFilter from '@/components/SpellListFilter.vue'
import { SpellFilter } from '@/util/spell-filter'

export default Vue.extend({
  name: 'SpellListview',
  data () {
    return {
      filter: {
        search: '',
        school: 'All',
        class: 'All',
        level: -1,
      } as SpellFilter,
    }
  },
  components: {
    SpellList,
    SpellListFilter,
  },
})
